export {default as mantenimientoR} from "./mantenimientoR/mantenimientoR";
export {default as instalacionR} from "./InstalacionR/instalacionR";
export {default as equipoR}  from "./EquipoR/equipoR"